import { CommonResponse } from '@gtpl/shared-models/masters';
import { Injectable } from '@nestjs/common';
import { AssetLocationMappingAdapter } from './entity/asset-location-mapping.adapter';
import { AssetLocationMappingDto } from './dto/asset-location-mapping.dto';
import { AssetLocationMapping } from './entity/asset-location-mapping.entity';
import { Raw, Repository, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { AssetLocationTransaction } from './entity/asset-location-transaction.entity';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { AssetLocationTransactionDto } from './dto/asset-location-transaction.dto';
import { Assets } from '../open-assets/open-assets-entity';
import { AssetMaintainanceService } from '../asset-maintainance/asset-maintainance.service';
//import {Item} from '../../../../masters/src/app/items/item.entity';
import appSettings from 'apps/services/config';
import { AssetStatusEnum } from 'libs/shared-models/common-models/src/lib/enum/asset-status.enum';
import { AssetByStatus } from '../open-assets/dto/asset-by-status.dto';
import { AssetTransactionDto } from '../open-assets/dto/asset-transaction-dto';
import { AssetTransaction } from '../open-assets/asset-transaction-entity';
import { AssetTransactionAdapter } from '../open-assets/dto/asset-transaction-adapter';

@Injectable()
export class AssetLocationMappingService {
  constructor(
    private adapter: AssetLocationMappingAdapter,
    @InjectRepository(AssetLocationMapping)
    private assetsRepository: Repository<AssetLocationMapping>,
    @InjectRepository(AssetLocationTransaction)
    private assetsTransactionRepo: Repository<AssetLocationTransaction>,
    private assetMaintainanceService: AssetMaintainanceService,
    @InjectRepository(Assets)
    private assetsRepo: Repository<Assets>,
    @InjectRepository(AssetTransaction)
    private assetTransRepo: Repository<AssetTransaction>,
    private assetTransAdapter: AssetTransactionAdapter
  ) {}

  // async create(createDto : AssetLocationMappingDto) : Promise<CommonResponse> {
  //     const getDto =[];
  //     try{
  //         const assetLocationMappingObj: {asset_id: number, assets_name: string, asset_location_id: number} =  await this.assetsRepository.createQueryBuilder('asset_loc')
  //         .select('assets.asset_id, assets.assets_name, asset_location_id')
  //         .leftJoin('asset_loc.assetsId', 'assets')
  //         .where(`assets.assets_code = '${createDto.assetId}'`)
  //         .getRawOne();
  //         const actAssetId = Number(assetLocationMappingObj.asset_id);
  //         await this.assetMaintainanceService.isAssetEligibleForLocation(actAssetId, createDto.locationId);
  //         let assetLocationId : number;
  //         const qry = `select item_name, asset_type from ${appSettings.masters_db}.items where item_id = ${assetLocationMappingObj.assets_name}`;
  //         const manager = getManager();
  //         const data: { item_name: string, asset_type: string }[] = await manager.query(qry);
  //         getDto.push(data[0])
  //         if(data[0].asset_type == 'FIXED'){
  //             const assetSave = await this.assetsRepo.update({assetId: actAssetId},{status:AssetStatusEnum.Running})
  //             const qry1 = `select owner_of_asset,assets_code from ${appSettings.assets_db}.assets where asset_id = ${actAssetId}`;
  //             const data1 : {owner_of_asset : string,asset_code: string}[] = await manager.query(qry1);
  //             // const qry2  = `select employee_name from ${appSettings.masters_db}.employee_details where employee_id = ${data1[0].owner_of_asset}`;
  //             // const data2 : {employee_name: string}[]= await manager.query(qry2);
  //             getDto.push(data1[0])

  //         }
  //         if(assetLocationMappingObj) {
  //             const assetLocationUpdate = await this.assetsRepository.update({assetLocationId : assetLocationMappingObj.asset_location_id},{locationId:createDto.locationId})
  //             assetLocationId = assetLocationMappingObj.asset_location_id;
  //         } else {
  //             const locationEntity = new AssetLocationMapping();
  //             locationEntity.assetsId = new Assets();
  //             locationEntity.assetsId.assetId = actAssetId;
  //             locationEntity.createdUser = createDto.createdUser;
  //             locationEntity.locationId = createDto.locationId;
  //             const assetLocationSave = await this.assetsRepository.save(locationEntity);
  //             assetLocationId = assetLocationSave.assetLocationId;
  //         }
  //         const transDto = new AssetLocationTransactionDto();
  //         transDto.assetLocationId = assetLocationId;
  //         transDto.assetId = actAssetId;
  //         transDto.locationId = createDto.locationId;
  //         transDto.status = 'Location Mapped'
  //         const transEntity = this.adapter.convertDtoToAssetLocationTransactionEnitity(transDto)
  //         const assetLocationTrans = await this.assetsTransactionRepo.save(transEntity);
  //         getDto.push(assetLocationTrans)
  //         const assetTransDto = new AssetTransactionDto();
  //         assetTransDto.assetId = actAssetId;
  //         assetTransDto.locationId = createDto.locationId;
  //         assetTransDto.status = AssetStatusEnum.LocationMapped;
  //         const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto)
  //         const statusTransactionSave = await this.assetTransRepo.save(assetTransEntity)
  //         return new CommonResponse(true,1,'Asset succesfully mapped to the location',getDto)

  //     } catch(err){
  //         throw err
  //     }
  // }

  async create(createDto: AssetLocationMappingDto): Promise<CommonResponse> {
    if (!Array.isArray(createDto.assetId)) {
      return new CommonResponse(
        false,
        0,
        'Invalid input: assetId should be an array.'
      );
    }

    const connection = getManager().connection;
    const queryRunner = connection.createQueryRunner();
    await queryRunner.connect();
    await queryRunner.startTransaction();

    try {
      const getDtos = [];
      const errors = [];

      for (const assetsCode of createDto.assetId) {
        try {
          const assetLocationMappingObj: {
            asset_id: number;
            assets_name: string;
            asset_location_id: number;
            plant:any;
          } = await this.assetsRepository
            .createQueryBuilder('asset_loc')
            .select('assets.asset_id, assets.assets_name, asset_location_id,assets.plant')
            .leftJoin('asset_loc.assetsId', 'assets')
            .where(`assets.assets_code = '${assetsCode}'`)
            .getRawOne();

          if (!assetLocationMappingObj) {
            errors.push(`Asset with code ${assetsCode} not found.`);
            continue;
          }
          console.log(createDto.plant,'oooooooooo')
          console.log(assetLocationMappingObj.plant,'oooooooooo')
          if (assetLocationMappingObj.plant !== createDto.plant) {
            errors.push(`Asset with code ${assetsCode} does not belong to the specified plant.`);
            continue;
        }

          const actAssetId = Number(assetLocationMappingObj.asset_id);
          // await this.assetMaintainanceService.isAssetEligibleForLocation(actAssetId, createDto.locationId);

          let assetLocationId: number;
          const qry = `select item_name, asset_type from ${appSettings.masters_db}.items where item_id = ${assetLocationMappingObj.assets_name}`;
          const manager = getManager();
          const data: {
            item_name: string;
            asset_type: string;
          }[] = await manager.query(qry);
          getDtos.push(data[0]);

          if (data[0].asset_type === 'FIXED') {
            await this.assetsRepo.update(
              { assetId: actAssetId },
              { status: AssetStatusEnum.Running }
            );
            const qry1 = `select owner_of_asset, assets_code from ${appSettings.assets_db}.assets where asset_id = ${actAssetId}`;
            const data1: {
              owner_of_asset: string;
              asset_code: string;
            }[] = await manager.query(qry1);
            getDtos.push(data1[0]);
          }

          if (assetLocationMappingObj.asset_location_id) {
            await this.assetsRepository.update(
              { assetLocationId: assetLocationMappingObj.asset_location_id },
              { locationId: createDto.locationId }
            );
            assetLocationId = assetLocationMappingObj.asset_location_id;
          } else {
            const locationEntity = new AssetLocationMapping();
            locationEntity.assetsId = new Assets();
            locationEntity.assetsId.assetId = actAssetId;
            locationEntity.createdUser = createDto.createdUser;
            locationEntity.locationId = createDto.locationId;
            const assetLocationSave = await this.assetsRepository.save(
              locationEntity
            );
            assetLocationId = assetLocationSave.assetLocationId;
          }

          const transDto = new AssetLocationTransactionDto();
          transDto.assetLocationId = assetLocationId;
          transDto.assetId = actAssetId;
          transDto.locationId = createDto.locationId;
          transDto.status = 'Location Mapped';
          const transEntity = this.adapter.convertDtoToAssetLocationTransactionEnitity(
            transDto
          );
          const assetLocationTrans = await this.assetsTransactionRepo.save(
            transEntity
          );
          getDtos.push(assetLocationTrans);

          const assetTransDto = new AssetTransactionDto();
          assetTransDto.assetId = actAssetId;
          assetTransDto.locationId = createDto.locationId;
          assetTransDto.status = AssetStatusEnum.LocationMapped;
          const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(
            assetTransDto
          );
          await this.assetTransRepo.save(assetTransEntity);

          // Update the asset_service owner after mapping
          const updateQuery = `
                    UPDATE shahi_assets.asset_service ass
                    JOIN shahi_assets.asset_location_mapping loc ON loc.asset_id = ass.asset_id
                    JOIN shahi_assets.location lcc ON lcc.location_id = loc.location_id
                    JOIN shahi_asset_master.employee_details emp ON emp.employee_id = lcc.location_head
                    SET ass.service_owner = emp.employee_name
                    WHERE ass.status = 'OPEN' AND ass.asset_id = ${actAssetId}`;

          await manager.query(updateQuery);


          if (createDto.locationId === 48 || createDto.locationId === 49 || createDto.locationId === 50 || createDto.locationId === 51 || createDto.locationId === 52 || createDto.locationId === 53
          ) {
            const updateAssetStatusQuery = `UPDATE ${appSettings.assets_db}.assets
              SET status = 'Idle', date_of_purchased = CURDATE()
              WHERE asset_id = ${actAssetId}`;

            await manager.query(updateAssetStatusQuery);
          }else{
            const updateAssetStatusQuery = `UPDATE ${appSettings.assets_db}.assets
            SET status = 'Running', date_of_purchased = CURDATE()
            WHERE asset_id = ${actAssetId}`;

          await manager.query(updateAssetStatusQuery);
          }
        } catch (err) {
          errors.push(
            `Error mapping asset with code ${assetsCode}: ${err.message}`
          );
        }
      }

      if (errors.length === 0) {
        await queryRunner.commitTransaction();
        return new CommonResponse(
          true,
          1,
          'All assets successfully mapped to the location',
          getDtos
        );
      } else {
        await queryRunner.rollbackTransaction();
        return new CommonResponse(
          false,
          0,
          'assets could not be mapped to the location / does not belong to the specified plant',
          getDtos
        );
      }
    } catch (err) {
      await queryRunner.rollbackTransaction();
      return new CommonResponse(false, 0, `Transaction failed: ${err.message}`);
    } finally {
      await queryRunner.release();
    }
  }

  // async create(createDto: AssetLocationMappingDto): Promise<CommonResponse> {
  //     if (!Array.isArray(createDto.assetId)) {
  //         return new CommonResponse(false, 0, 'Invalid input: assetId should be an array.');
  //     }

  //     const getDtos = [];
  //     const errors = [];

  //     for (const assetsCode of createDto.assetId) {
  //         try {
  //             const assetLocationMappingObj: { asset_id: number; assets_name: string; asset_location_id: number } =
  //                 await this.assetsRepository.createQueryBuilder('asset_loc')
  //                     .select('assets.asset_id, assets.assets_name, asset_location_id')
  //                     .leftJoin('asset_loc.assetsId', 'assets')
  //                     .where(`assets.assets_code = '${assetsCode}'`)
  //                     .getRawOne();

  //             if (!assetLocationMappingObj) {
  //                 errors.push(`Asset with code ${assetsCode} not found.`);
  //                 continue;
  //             }

  //             const actAssetId = Number(assetLocationMappingObj.asset_id);
  //             await this.assetMaintainanceService.isAssetEligibleForLocation(actAssetId, createDto.locationId);

  //             let assetLocationId: number;
  //             const qry = `select item_name, asset_type from ${appSettings.masters_db}.items where item_id = ${assetLocationMappingObj.assets_name}`;
  //             const manager = getManager();
  //             const data: { item_name: string; asset_type: string }[] = await manager.query(qry);
  //             getDtos.push(data[0]);

  //             if (data[0].asset_type === 'FIXED') {
  //                 await this.assetsRepo.update({ assetId: actAssetId }, { status: AssetStatusEnum.Running });
  //                 const qry1 = `select owner_of_asset, assets_code from ${appSettings.assets_db}.assets where asset_id = ${actAssetId}`;
  //                 const data1: { owner_of_asset: string; asset_code: string }[] = await manager.query(qry1);
  //                 getDtos.push(data1[0]);
  //             }

  //             if (assetLocationMappingObj.asset_location_id) {
  //                 await this.assetsRepository.update({ assetLocationId: assetLocationMappingObj.asset_location_id }, { locationId: createDto.locationId });
  //                 assetLocationId = assetLocationMappingObj.asset_location_id;
  //             } else {
  //                 const locationEntity = new AssetLocationMapping();
  //                 locationEntity.assetsId = new Assets();
  //                 locationEntity.assetsId.assetId = actAssetId;
  //                 locationEntity.createdUser = createDto.createdUser;
  //                 locationEntity.locationId = createDto.locationId;
  //                 const assetLocationSave = await this.assetsRepository.save(locationEntity);
  //                 assetLocationId = assetLocationSave.assetLocationId;
  //             }

  //             const transDto = new AssetLocationTransactionDto();
  //             transDto.assetLocationId = assetLocationId;
  //             transDto.assetId = actAssetId;
  //             transDto.locationId = createDto.locationId;
  //             transDto.status = 'Location Mapped';
  //             const transEntity = this.adapter.convertDtoToAssetLocationTransactionEnitity(transDto);
  //             const assetLocationTrans = await this.assetsTransactionRepo.save(transEntity);
  //             getDtos.push(assetLocationTrans);

  //             const assetTransDto = new AssetTransactionDto();
  //             assetTransDto.assetId = actAssetId;
  //             assetTransDto.locationId = createDto.locationId;
  //             assetTransDto.status = AssetStatusEnum.LocationMapped;
  //             const assetTransEntity = this.assetTransAdapter.convertAssetTransactionDtoToEntity(assetTransDto);
  //             await this.assetTransRepo.save(assetTransEntity);
  //         } catch (err) {
  //             errors.push(`Error mapping asset with code ${assetsCode}: ${err.message}`);
  //         }
  //     }

  //     const success = errors.length === 0;
  //     const message = success ? 'All assets successfully mapped to the location' : 'Some assets could not be mapped to the location';

  //     return new CommonResponse(success, success ? 1 : 0, message, getDtos);
  // }

  async getLocationMappedAssets(req?: AssetByStatus): Promise<CommonResponse> {
    const manager = getManager();
    let getEntities =
      `SELECT aas.asset_id,aas.assets_name,aas.asset_serialno,aas.assets_code,aas.asset_type,aas.asset_category,aas.date_of_purchased,aas.plant,aas.asset_mode,lom.location_id,lo.location_name,unc.unit_name,unc.unit_code_id,isc.item_sub_category,it.item_name,datediff(date(now()),aas.date_of_purchased) as assetAge
         FROM  ` +
      appSettings.assets_db +
      `.assets aas 
         LEFT JOIN ` +
      appSettings.assets_db +
      `.asset_location_mapping lom ON lom.asset_id = aas.asset_id 
         LEFT JOIN ` +
      appSettings.assets_db +
      `.location lo ON lo.location_id = lom.location_id 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.unitcodes unc ON unc.unit_code_id = aas.plant 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.items it ON it.item_id = aas.assets_name
         WHERE aas.asset_id IN(SELECT asset_id FROM ` +
      appSettings.assets_db +
      `.asset_location_mapping)`;
    if (req.assetCode) {
      getEntities =
        getEntities + ' and aas.assets_code = "' + req.assetCode + '"';
    }
    if (req.plantId) {
      getEntities = getEntities + ' and aas.plant = ' + req.plantId + '';
    }
    if (req.location) {
      getEntities =
        getEntities + ' and lo.location_name = "' + req.location + '"';
    }
    if (req.assetCategory) {
      getEntities =
        getEntities + ' and aas.asset_category = ' + req.assetCategory + '';
    }
    if (req.assetMode) {
      getEntities =
        getEntities + ' and aas.asset_mode = "' + req.assetMode + '"';
    }
    if (req.assetType) {
      getEntities =
        getEntities + ' and aas.asset_type = "' + req.assetType + '"';
    }
    getEntities = getEntities + ' ORDER BY it.item_name ASC';
    const assetdata = await manager.query(getEntities);
    return new CommonResponse(
      true,
      1,
      'Data retrieved successfully',
      assetdata
    );
  }

  async getLocationUnmappedAssets(
    req?: AssetByStatus
  ): Promise<CommonResponse> {
    const manager = getManager();
    let getEntities =
      `SELECT aas.asset_id,aas.assets_name,aas.asset_serialno,aas.assets_code,aas.asset_type,aas.asset_category,aas.date_of_purchased,aas.plant,aas.asset_mode,lom.location_id,lo.location_name,unc.unit_name,isc.item_sub_category,it.item_name,datediff(date(now()),aas.date_of_purchased) as assetAge
         FROM  ` +
      appSettings.assets_db +
      `.assets aas 
         LEFT JOIN ` +
      appSettings.assets_db +
      `.asset_location_mapping lom ON lom.asset_id = aas.asset_id 
         LEFT JOIN ` +
      appSettings.assets_db +
      `.location lo ON lo.location_id = lom.location_id 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.unitcodes unc ON unc.unit_code_id = aas.plant 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category 
         LEFT JOIN ` +
      appSettings.masters_db +
      `.items it ON it.item_id = aas.assets_name
         WHERE aas.asset_id NOT IN(SELECT asset_id FROM ` +
      appSettings.assets_db +
      `.asset_location_mapping)`;
    if (req.assetCode) {
      getEntities =
        getEntities + ' and aas.assets_code = "' + req.assetCode + '"';
    }
    if (req.plantId) {
      getEntities = getEntities + ' and aas.plant = ' + req.plantId + '';
    }
    if (req.location) {
      getEntities =
        getEntities + ' and lo.location_name = "' + req.location + '"';
    }
    if (req.assetCategory) {
      getEntities =
        getEntities + ' and aas.asset_category = ' + req.assetCategory + '';
    }
    if (req.assetMode) {
      getEntities =
        getEntities + ' and aas.asset_mode = "' + req.assetMode + '"';
    }
    if (req.assetType) {
      getEntities =
        getEntities + ' and aas.asset_type = "' + req.assetType + '"';
    }
    getEntities = getEntities + ' ORDER BY it.item_name ASC';
    const assetdata = await manager.query(getEntities);
    return new CommonResponse(
      true,
      1,
      'Data retrieved successfully',
      assetdata
    );
  }

  async getassetCodeDropDownforLocationMapping(
    req?: AssetByStatus
  ): Promise<CommonResponse> {
    const manager = getManager();
    let getEntities =
      `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.plant,it.item_name,aas.asset_category
        FROM ` +
      appSettings.assets_db +
      `.assets aas
        LEFT JOIN ` +
      appSettings.masters_db +
      `.items it ON it.item_id = aas.assets_name
        WHERE aas.asset_id >0 and aas.status IN ('Idle','Running')`;
    if (req.assetCode) {
      getEntities =
        getEntities + ' and aas.assets_code = "' + req.assetCode + '"';
    }
    if (req.plantId && req.plantId !== 5) {
      getEntities = getEntities + ' and aas.plant = ' + req.plantId + '';
    }
    if (req.assetCategory) {
      getEntities =
        getEntities + ' and aas.asset_category = ' + `'${req.assetCategory}'` + '';
    }
    if (req.assetType) {
      getEntities =
        getEntities + ' and aas.asset_type = "' + req.assetType + '"';
    }
    getEntities = getEntities + ' ORDER BY it.item_name';
    const assetdata = await manager.query(getEntities);

    return new CommonResponse(
      true,
      1,
      'Data retrieved successfully',
      assetdata
    );
  }

  async getassetCategoryDropDownforLocationMapping(
    req?: AssetByStatus
  ): Promise<CommonResponse> {
    const manager = getManager();
    let getEntities =
      `SELECT aas.asset_id,aas.assets_code,aas.assets_name,aas.plant,aas.asset_category,isc.item_sub_category,isc.item_sub_category_id
        FROM ` +
      appSettings.assets_db +
      `.assets aas
        LEFT JOIN ` +
      appSettings.masters_db +
      `.item_sub_categories isc ON isc.item_sub_category_id = aas.asset_category
        WHERE aas.asset_id >0 and aas.status = '${AssetStatusEnum.Idle}'`;
    if (req.plantId && req.plantId !== 5) {
      getEntities = getEntities + ' and aas.plant = ' + req.plantId + '';
    }
    getEntities =
      getEntities +
      ' GROUP BY isc.item_sub_category ORDER BY isc.item_sub_category ASC';
    const assetdata = await manager.query(getEntities);

    return new CommonResponse(
      true,
      1,
      'Data retrieved successfully',
      assetdata
    );
  }
}
